function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

var simulateClick = function (elem) {
    // Create our event (with options)
    var evt = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
    });
    // If cancelled, don't dispatch our event
    var canceled = !elem.dispatchEvent(evt);
};

var checked_values = function (node) {
    var checked;
    if (!node) node = document;
    checked = node.querySelectorAll('input[type="checkbox"]:checked');
    return Array.prototype.map.call(checked, function (e) { return e.value; });
};

var getClosest = function (elem, selector) {

    // Element.matches() polyfill
    if (!Element.prototype.matches) {
        Element.prototype.matches =
            Element.prototype.matchesSelector ||
            Element.prototype.mozMatchesSelector ||
            Element.prototype.msMatchesSelector ||
            Element.prototype.oMatchesSelector ||
            Element.prototype.webkitMatchesSelector ||
            function (s) {
                var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                    i = matches.length;
                while (--i >= 0 && matches.item(i) !== this) { }
                return i > -1;
            };
    }

    // Get the closest matching element
    for (; elem && elem !== document; elem = elem.parentNode) {
        if (elem.matches(selector)) return elem;
    }
    return null;

};

var merge = function () {
    var obj = {},
        i = 0,
        il = arguments.length,
        key;
    for (; i < il; i++) {
        for (key in arguments[i]) {
            if (arguments[i].hasOwnProperty(key)) {
                obj[key] = arguments[i][key];
            }
        }
    }
    return obj;
};

function serialize(form) {
    var inputs = form.elements;
    var array = {};
    for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].type == "radio") {
            if (inputs[i].checked === true) {
                array[inputs[i].name] = inputs[i].value;
            }
        }
        else {
            array[inputs[i].name] = inputs[i].value;
        }
    }
    return array;
}

function check_fields(form_id) {
    var form = document.getElementById(form_id);
    var form_elements = form.elements;
    var errors = false;

    for (var i = 0, element; !!(element = form_elements[i]); i += 1) {
        if (element.value === "" && element.hasAttribute('required')) {
            if (element.tagName == "SELECT") {
                element.parentNode.classList.add("error")
            }
            else {
                element.classList.add('error');
            }
            errors = true;
        }
        else if (element.name == "email" && !validateEmail(element.value)) {
            element.classList.add("error");
            errors = true;
        }
        else {
            element.parentNode.classList.remove("error")
            element.classList.remove("error");
        }
    }
    return errors;
}



function currentYPosition() {
    // Firefox, Chrome, Opera, Safari
    if (self.pageYOffset) return self.pageYOffset;
    // Internet Explorer 6 - standards mode
    if (document.documentElement && document.documentElement.scrollTop)
        return document.documentElement.scrollTop;
    // Internet Explorer 6, 7 and 8
    if (document.body.scrollTop) return document.body.scrollTop;
    return 0;
}




function elmYPosition(eID) {
    var elm = document.getElementById(eID);
    var y = elm.offsetTop;
    var node = elm;
    while (node.offsetParent && node.offsetParent != document.body) {
        node = node.offsetParent;
        y += node.offsetTop;
    } return y;
}



function email_verification($s_email) {
    var getUrl = window.location;
    var baseUrl = getUrl.protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[1];
    var data = new FormData();

    var payload = {
        userEmail: $s_email
    };

    data.append("data", JSON.stringify(payload));
    return fetch(baseUrl + '/ajax/email-verification',
        {
            method: "POST",
            body: data
        }
    ).then(function (res) {
        return res.json()
    }).then(function (res) {
        return res.success;
    }).catch();
}


function getQueryStringValue(key) {
    return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
}

var handleClickVideo = function (event) {
    event = event || window.event;
    var element = event.target;
    var html = document.querySelector('html');
    var iframe_youtube = document.getElementById('iframe_youtube');
    var modal_video = document.querySelector('.youtube_modal_container');



    while (element) {

        if (element.nodeName === "A" && /youtube_modal/.test(element.className)) {
            event.preventDefault();
            var id = element.dataset.video;

            var iframe_url = "https://www.youtube.com/embed/" + id + "?rel=0&amp;controls=0&amp;showinfo=0&amp;autoplay=1";
            iframe_youtube.src = iframe_url;
            modal_video.classList.add('__displayed');
            break;
        }
        element = element.parentNode;
    }
};
if (document.querySelector('.youtube_modal')) {
    document.addEventListener("click", handleClickVideo, false);
}

if (document.querySelector('.close_modal')) {
    var close_modal = document.querySelector('.close_modal');

    close_modal.addEventListener("click", function (e) {
        e.preventDefault();
        document.querySelector('.youtube_modal_container').classList.remove('__displayed');
    });
}

var offsetHeight = function (ctn) {
    var height = ctn.offsetHeight;
    var style = getComputedStyle(ctn);
    height += parseInt(style.marginTop) + parseInt(style.marginBottom);
    return height + 'px';
}

function registerClone_item(data) {
    var elem = document.querySelector(".clone-item"),
        clone = elem.cloneNode(true);

    clone.querySelector(".name").innerHTML = data.firstname + ' ' + data.lastname;
    clone.querySelector(".thumb").style.backgroundImage = 'url(' + data.thumbnail + ')';
    clone.querySelector(".jobTitle").innerHTML = data.job_title;
    if(data.availability === 1) clone.querySelector(".avail").classList.add('none');
    clone.querySelector(".avail").innerHTML = data.app_next_avail;
    clone.querySelector(".score").innerHTML = data.score;
    clone.dataset.serial = data.serial;

    if (data.video == null || data.video.length <= 0) {
        clone.querySelector(".triggerVideo").style.display = 'none';
    }
    else {
        clone.querySelector(".triggerVideo").dataset.video = data.video;
    }

    if(document.querySelector(".calendar-container")) {
        clone.querySelector(".calendar-container").dataset.serial = data.serial;
        clone.querySelector(".calendar-container").dataset.loadcalendar = true;
    }
    

    return clone;
}

function registerClone_item_list(data) {
    var elem = document.querySelector(".clone-item"),
        clone = elem.cloneNode(true);

    clone.querySelector(".name").innerHTML = data.firstname + ' ' + data.lastname;
    clone.querySelector(".thumb").style.backgroundImage = 'url(' + data.thumbnail + ')';
    clone.querySelector(".jobTitle").innerHTML = data.job_title;
    clone.querySelector(".score").innerHTML = data.score;
    clone.dataset.serial = data.serial;

    if (data.video == null || data.video.length <= 0) {
        clone.querySelector(".triggerVideo").style.display = 'none';
    }
    else {
        clone.querySelector(".triggerVideo").dataset.video = data.video;
    }
    clone.querySelector(".show-more").href = "/fr/praticien/"+data.referer;

    var appointmentRequest = clone.querySelector(".appointmentRequest");
    appointmentRequest.href = appointmentRequest.href+"?appointment-request="+data.serial;

    if(document.querySelector(".calendar-container")) {
        clone.querySelector(".calendar-container").dataset.serial = data.serial;
        clone.querySelector(".calendar-container").dataset.referer = data.referer;
        clone.querySelector(".calendar-container").dataset.loadcalendar = true;    
    }
    

    return clone;
}


var fetchCalendar = function (element, limit) {
    var containerParent = getClosest(element, '.calendar-container')

    var queryType = element.dataset.type == undefined ? 'init' : element.dataset.type;

    var payload = {
        type: queryType,
        serial: containerParent.dataset.serial,
        limit: limit,
        start: element.classList.contains('nextSlots') ? element.dataset.start : containerParent.dataset.start,
        end: element.classList.contains('nextSlots') ? element.dataset.end : containerParent.dataset.end
    };

    var data = new FormData();
    data.append("data", JSON.stringify(payload));
    fetch(baseUrl + '/ajax/getPsySlots',
        {
            method: "POST",
            credentials: 'include',
            body: data
        }
    ).then(function (res) {
        return res.json()
    }).then(function (res) {
        if (res.success === true) {
            var now = new Date(new Date().setDate(new Date().getDate() + 1));

            var start = new Date(res.start);
            var prevSelector = containerParent.querySelector('.arrowPrev');
            if (now >= start) {
                prevSelector.classList.add('hide')
            }
            else {
                prevSelector.classList.remove('hide')
            }
            containerParent.querySelector('.table').innerHTML = res.formated_results
            containerParent.dataset.start = res.start;
            containerParent.dataset.end = res.end;
        }
        else {

        }
    }).catch();
}

var loadCalendars = function (event) {
    var triggers = document.querySelectorAll('[data-loadcalendar=true]'), i;

    for (i = 0; i < triggers.length; ++i) {
        fetchCalendar(triggers[i], true);
        triggers[i].dataset.loadcalendar = false;
    }
}
